import { render, staticRenderFns } from "./Mhemodinamico.vue?vue&type=template&id=67fa21f0"
import script from "./Mhemodinamico.vue?vue&type=script&lang=js"
export * from "./Mhemodinamico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports